import { memo } from "react";
import { useSelector } from "react-redux";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import { ThemedEditIcon } from "assets/CXFIcons/Portal/Profile";
import { useTranslation } from "react-i18next";

const ButtonRename = ({ renameNode, allowEditWorkflow }) => {
  const { t } = useTranslation("flowDesigner");
  const { currentSavedFlow } = useSelector((state) => state.designer.flows);
  const isActiveFlow = currentSavedFlow?.shared_status === "active";

  return (
    <Tooltip title={t("buttons.edit")} placement="top">
      <IconButton
        aria-label="rename"
        size="small"
        style={{ width: "100%", height: "100%" }}
        onClick={renameNode}
        disabled={isActiveFlow || !allowEditWorkflow}
      >
        <ThemedEditIcon width="20px" height="20px" color="currentColor" />
      </IconButton>
    </Tooltip>
  );
};

export default memo(ButtonRename);
